
import styles from './index.module.scss'
import eventBus from '@utils/eventBus';
import { SELECT_ORG_TYPE } from '@utils/CONST'
import { useNavigate } from 'react-router-dom';
import Utils from '@utils/utils';
import { BATCH_IMAGES_TYPE } from '@utils/CONST';
import API from '@api/api'

const list = [{
    title: 'AI试衣 ',
    smallTitle: '平铺商品图秒上身',
    value: BATCH_IMAGES_TYPE.TRYON_BATCH,
}, {
    title: '换模特',
    smallTitle: '海量模特随心换',
    value: BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH,
}, {
    title: '换背景',
    smallTitle: '室内户外场景任选',
    value: BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH,
}, 
// {
//     title: '商品智能堆叠',
//     smallTitle: '组合商品智能拼',
//     value: BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH,
// }, 
{
    title: '同款换色',
    smallTitle: '模特衣服智能换色',
    value: BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH,
}, 
// {
//     title: '智能详情页',
//     smallTitle: '智能详情页',
//     value: BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH,
// }, 
{
    title: 'AI超清',
    smallTitle: 'AI超清',
    value: BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH,
}, {
    title: '去水印',
    smallTitle: '去水印',
    value: BATCH_IMAGES_TYPE.WATERMARK_REMOVE_BATCH,
}, {
    title: '搭配上身',
    smallTitle: '搭配上身',
    value: BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH,
}]


const DefaultEmpytPage = (props) => {
    const { disabledTitle } = props
    const navigate = useNavigate()

    const createClick = (item) => {
        const isLogin = Utils.checkLoginStatus(() => loginAfter(item))
        if (!isLogin) return
        loginAfter(item)
    }
    const loginAfter = (item) => {
        API.getUserOrgInfo({}).then((res) => {
            if (res.code == 0) {
                const isPersonal = !res.data.current || !res.data.current?.id
                if (isPersonal) {
                    if (res?.data?.orgList?.length > 1) {
                        eventBus.emit('OPEN_SELECT_TEAM', { type: SELECT_ORG_TYPE.CHANGEORG, noPersonal: true })
                    } else eventBus.emit('OPEN_CREATE_TEAM')
                } else navigate(`/home/product/${item.value}/upload`)
            }
        })
    }

    return (
        <div className={`${styles.DefaultEmpytPage} _beauty_scrollbar`}>
            {
                (
                    <div className={`${styles.listWarpBox}`}>
                        {!disabledTitle && <p className={styles.listWarpTitile}>PSAI企业专属功能 — 批量生图</p>}
                        <div className={`${styles.listWarp}`}>
                            {
                                list.map((item, index) => (
                                    <div key={item.value}
                                        className={`${styles.listItem} ${styles[`listItem${index + 1}`]}`}
                                        onClick={() => createClick(item)}>
                                        <div className={styles.imgBox}></div>
                                        <p className={styles.title}>{item.title}</p>
                                    </div>
                                ))
                            }
                            <div className={`${styles.listItem}`} style={{ paddingTop: '40px', cursor: 'default' }}>
                                <p className={styles.listWarp_p}>更多功能</p>
                                <p className={styles.listWarp_p}>敬请期待</p>
                            </div>
                        </div>
                    </div>
                )
            }
        </div>
    )
}

export default DefaultEmpytPage